module.exports = __webpack_public_path__ + "img/img7.b5b0da44.png";